import _core from "./core";
import _drag from "./drag";
import _prevNextButton from "./prev-next-button";
import _pageDots from "./page-dots";
import _player from "./player";
import _addRemoveCell from "./add-remove-cell";
import _lazyload from "./lazyload";
import _imagesloaded from "./imagesloaded";
var exports = {};

/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */
if (exports) {
  const Flickity = _core;
  _drag;
  _prevNextButton;
  _pageDots;
  _player;
  _addRemoveCell;
  _lazyload;
  _imagesloaded;
  exports = Flickity;
}

export default exports;